<template>
  <div class="artinvest-view">
    <Loader :loading="showLoader" />
    <v-toolbar color="#222222" flat dense class="mb-4">
      <v-icon color="#337b52" class="ml-2" size="40" @click="router.go(-1)">mdi-arrow-left-bold-circle</v-icon>
      <v-toolbar-title style="font-family: 'Material Design Icons'; font-size: 25px !important">
        Art-Invest
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-container fluid class="main-content px-4">
      <v-row justify="center" align="stretch" class="ma-0">

        <v-col cols="12" sm="6" md="4" lg="3" class="pa-3 d-flex">
          <v-card class="elegant-card no-transition" @click="goToDetails('presentation')">
            <img :src="require('@/assets/Branding/Artinvest/artinvest_unternehmenspräsentation.jpg')"
              class="card-image" />
            <div class="card-bottom">
              <div class="card-title">Unternehmenspräsentation</div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" class="pa-3 d-flex">
          <v-card class="elegant-card no-transition" @click="goToDetails('projects')">
            <img :src="require('@/assets/Branding/Artinvest/artinvest_projects_collage.jpg')" class="card-image" />
            <div class="card-bottom">
              <div class="card-title">Art-Invest Projekte</div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" class="pa-3 d-flex">
          <v-card class="elegant-card no-transition" @click="goToDetails('films')">
            <video class="card-image" autoplay loop muted playsinline>
              <source src="https://www.art-invest.de/wp-content/uploads/2022/01/Art-Invest-Intro_Film-Website.mp4"
                type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div class="card-bottom">
              <div class="card-title">Art-Invest Filme</div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" class="pa-3 d-flex">
          <v-card class="elegant-card no-transition" @click="goToDetails('esg')">
            <img :src="require('@/assets/Branding/Artinvest/HomeViewPictures/artinvest_esg_cover.jpg')"
              class="card-image" />
            <div class="card-bottom">
              <div class="card-title">Environmental, Social and Governance (ESG)</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- PDF Viewer Modal -->
    <div v-if="pdfDialog" class="modal-overlay" @click.self="closePdf">
      <div class="modal-content">
        <button class="modal-close" @click="closePdf">✖</button>
        <div class="pdf-viewer">
          <PDF v-if="pdfSrc" :src="pdfSrc" @onComplete="onPdfComplete" class="pdf-viewer-content" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import PDF from "pdf-vue3";
import { useRouter } from "vue-router";
import Loader from "@/components/Loader.vue";
import { getToolBarLogo } from "@/assets/Branding/branding.js";

export default {
  name: "ArtInvestView",
  components: {
    Loader,
    PDF,
  },
  setup() {
    const router = useRouter();
    const showLoader = ref(true);
    const pdfDialog = ref(false);
    const pdfSrc = ref("");
    const pdfLoading = ref(true);
    const logo = ref("");

    const goToDetails = (route) => {
      if (route === 'presentation') {
        viewPdf("/pdfs/aire-presentation.pdf");
      }
      if (route === 'projects') {
        router.push({ name: 'ProjectsList' }).catch((err) => console.error("Routing error:", err));
      }
      if (route === 'films') {
        router.push({ name: 'ProjectFilmsList' }).catch((err) => console.error("Routing error:", err));
      }
      if (route === 'esg') {
        router.push({ name: 'ESG' }).catch((err) => console.error("Routing error:", err));
      }
    };

    const viewPdf = (link) => {
      const isPpt = link.endsWith(".ppt") || link.endsWith(".pptx");
      pdfSrc.value = isPpt
        ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(link)}`
        : link;
      pdfDialog.value = true;
    };

    const closePdf = () => {
      pdfDialog.value = false;
    };

    const onPdfComplete = () => {
      showLoader.value = false;
    };

    onMounted(async () => {
      logo.value = await getToolBarLogo();
      setTimeout(() => {
        showLoader.value = false;
      }, 1200);
    });

    return {
      router,
      goToDetails,
      showLoader,
      logo,
      pdfDialog,
      pdfSrc,
      pdfLoading,
      viewPdf,
      closePdf,
      onPdfComplete
    };
  },
};
</script>

<style scoped>
.toolbar-icon {
  height: 30px;
  align-self: center;
  margin-right: 20px;
}

.elegant-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: none !important;
  animation: none !important;
}

.card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.card-bottom {
  background-color: #fff;
  width: 100%;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.card-title {
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  color: #000;
}

/* PDF Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 95%;
  max-width: 1000px;
  height: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.modal-close {
  position: absolute;
  top: -15px;
  right: -0.1px;
  background: #ffffff;
  border: none;
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-close:hover {
  background: #f1f1f1;
}

.pdf-viewer {
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.pdf-viewer-content {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>